import { UI_API_METHOD_TYPES } from '@sdk/api/modules/ui/types.ui'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * This event is used for appJson.module.canvas.start_in_loading_mode: true apps.
 * A loading curtain is displayed until you call this event.
 *
 * @example
 * useUi().embeddableReady()
 *
 */
export async function embeddableReady(): Promise<void> {
  const pr = await usePostRobot()
  await pr.send(window.parent, UI_API_METHOD_TYPES.UI_EMBEDDABLE_READY)
}
